import { render, staticRenderFns } from "./QuestionLayoutB.vue?vue&type=template&id=032c7e82&scoped=true&"
import script from "./QuestionLayoutB.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutB.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutB.vue?vue&type=style&index=0&id=032c7e82&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c7e82",
  null
  
)

export default component.exports